<span [title]="firstName() + ' ' + lastName()">{{initials}}</span>